import gql from "graphql-tag";
import api from "../apiClient";

export default {
  readByDescription: (input) =>
    api
      .send({
        query: gql`
          query readByDescription($input: String!) {
            TYPES {
              Cabys {
                readByDescription(input: $input) {
                  id
                  cabys
                  descripcion_cabys
                  impuesto
                }
              }
            }
          }
        `,
        variables: {
          input,
        },
      })
      .then((result) => result.data.data.TYPES.Cabys.readByDescription),
};
